module.exports = __webpack_public_path__ + "images/emoji/credit_card.1c7c9c5c6e7926d76fab.png";